// 限制級確認彈窗
'use client';
import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { urlState } from '@/slices/urlSlice';
import { userMutate } from '@/slices/userSlice';
import authClient from '@/common/apiClient/authClient';
import { sendInteractMsgToOther } from '@/common/socketFunctions';
import Image from 'next/image';

const content = {
    tw: {
        title: '您滿18歲了嗎？',
        content: '本網站已依照台灣網站內容分級規定處理，作品內容含有成年者才可觀看之限制級內容',
    },
    cn: {
        title: '您满18岁了吗？',
        content: '本网站已依照台湾网站内容分级规定处理，作品内容含有成年者才可观看之限制级内容',
    },
};

const AdultConfirmModal = ({ locale, isAdult, uid }) => {
    const dispatch = useDispatch();
    const { web1Url } = useSelector(urlState);
    const [showModal, setShowModal] = useState(!isAdult);

    // 處理 user 18 狀態
    const handleUserMutate = async () => {
        dispatch(userMutate({ is18: true, is18Time: true }));
        // 發通知到其他裝置
        const payload = {
            uid,
            userChange: { is18: 1 },
        };
        await sendInteractMsgToOther(payload);
        await authClient.postAgeLimitState();
    };

    // 點擊成年
    const onClick = async () => {
        // 如果已登入
        if (uid) {
            try {
                const { message } = await authClient.toggleAdultState();
                if (message === 'success') handleUserMutate();
            } catch (e) {
                console.error(e);
            }
        } else {
            // 設定 cookie
            const days = 1;
            const date = new Date();
            date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
            const expires = date.toUTCString();

            document.cookie = `isAdult=1;expires=${expires};path=/;Secure;SameSite=Lax;`;
        }

        setShowModal(false);
    };

    if (showModal)
        return (
            <div className="modal bg-[#8c4b74] bg-opacity-[.86] backdrop-blur-[7px] z-[100]">
                <div className="space-y-[55px] w-[400px] !max-w-[88vw] mx-auto usm:space-y-[40px] uxs:!space-y-[30px]">
                    <div className="flex gap-x-[32px] text-white items-center w-full usm:gap-x-[25px] uxs:flex-col uxs:gap-y-[30px]">
                        <div className="img-box w-[98px] aspect-[1/1] usm:w-[75px]">
                            <Image
                                width={98}
                                height={98}
                                src="/images/icon/icon_18.svg"
                                alt="icon"
                            />
                        </div>

                        <div className="space-y-[20px] uxs:text-center">
                            <p className="text-h1 usm:text-h2">{content?.[locale]?.title}</p>
                            <p className="text-btn4">{content?.[locale]?.content}</p>
                        </div>
                    </div>

                    <div
                        className="flex gap-x-[20px] items-center justify-between
                        [&>button]:rounded-[40px] text-btn1 [&>button]:trans [&>button]:flex-grow
                        [&>button]:py-[14px]"
                    >
                        <button
                            onClick={() => (window.location.href = web1Url)}
                            className="text-[#fff] border-1 border-[rgba(199,199,199,0.4)]"
                        >
                            NO
                        </button>
                        <button
                            onClick={onClick}
                            className="text-[#393939] bg-[#fff] border-1 border-[rgba(199,199,199,0.4)] hover:text-[#c7c7c7] hover:bg-[#1e1e1e]"
                        >
                            YES
                        </button>
                    </div>
                </div>
            </div>
        );

    return null;
};

export default AdultConfirmModal;
